import { render, staticRenderFns } from "./ViewDetailModal.vue?vue&type=template&id=2a459ce3&scoped=true&"
import script from "./ViewDetailModal.vue?vue&type=script&lang=js&"
export * from "./ViewDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailModal.vue?vue&type=style&index=0&id=2a459ce3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a459ce3",
  null
  
)

export default component.exports